import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { HelmetProvider } from 'react-helmet-async';
import AppRoutes from './routes/AppRoutes';
import { Analytics } from '@vercel/analytics/react';

function App() {
  return (
    <ThemeProvider>   
      <HelmetProvider> 
      <Router>
        {navigator.userAgent !== 'ReactSnap' && <Analytics />}
        <AppRoutes />
      </Router>
      </HelmetProvider>
    </ThemeProvider>
  );
}

export default App;
